import React, { useCallback } from 'react';
import { Map } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';
import type { ActionEntity } from './hooks/useScopedActionForm';
import { getActionCoordinates } from './utils/actionGeolocation';
import { formatActionTask } from './utils/actionTask';
import { openActionMapPopup } from './openActionMapPopup';

type ActionMapButtonProps = {
  action: ActionEntity;
};

export const ActionMapButton: React.FC<ActionMapButtonProps> = ({ action }) => {
  const { mapView, setIsMapVisible } = useUscgMapContext();
  const coords = getActionCoordinates(action.geolocation);
  const taskLabel = formatActionTask(action.name, action.description);

  const onClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!coords) return;
      setIsMapVisible(true);
      if (!mapView) return;
      await openActionMapPopup({ mapView, action });
    },
    [action, coords, mapView, setIsMapVisible]
  );

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      title={coords ? 'Zoom map to action location' : 'No location set'}
      aria-label={
        coords ? `Show ${taskLabel || 'action'} on map` : 'No location set'
      }
      disabled={!coords}
      onClick={onClick}
    >
      <Map className="tw:size-4" />
    </Button>
  );
};
